<template>
  <div class="overview-item no-margin">
    <div class="item-label bold-item">
      {{tc('booking.total')}}
    </div>
    <div class="item-value">
      {{totalDisplay}}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'cart-totals',
  computed: {
    ...mapGetters('i18n', ['tc']),
    ...mapState('cart', ['cart']),
    ...mapState('booking', ['query']),
    ...mapGetters('currency', ['getDisplayPrice', 'currencyData']),
    totalDisplay() {
      return this.getDisplayPrice({price: this.cart.totals.total, withIsoCode: true, isoAfter: true})
    }
  },
}
</script>